import {combineReducers} from 'redux'

import browser from './browser'
import connectionState from './connectionState'
import currentUser from './currentUser'
import usersReducer from './users'
import userSorting from './userSorting'
// import roomMessages from './roomMessages'
import myVideoWindow from './myVideoWindow'
import streamingStatus from './streamingStatus'
import videoStreams from './videoStreams'
import fullscreen from './fullscreen.ts'
import watchingMe from './watchingMe'
import currentRoom from './currentRoom'
import roomsReducer from './rooms'
import visibleChatrooms from './visibleChatrooms'
import editorStyle from './editorStyle'
import editorAttachments from './editorAttachments'
import sidebars from './sidebars'
import notifications from './notifications'
import restart from './restart.ts'
import visibility from './visibility'

import pm from 'pm-js/build/reducers/pmConversations'

let noop = function(state = {}, action) {
  return state;
};

let reducers = combineReducers({
  browser,
  connectionState,
  currentUser: noop,
  userSorting,
  // roomMessages,
  pm: pm,
  streamingStatus,
  myVideoWindow,
  videoStreams,
  fullscreen: noop,
  watchingMe,
  currentRoom,
  rooms: noop,
  editorStyle,
  editorAttachments,
  sidebars,
  visibleChatrooms,
  users: noop,
  notifications,
  restart: restart,
  visibility: visibility
});

function myReducers(state, action) {
  state.currentUser = currentUser(state.currentUser, action);
  state.users = usersReducer(state.users, action, state);
  state.rooms = roomsReducer(state.rooms, action, state);
  state.fullscreen = fullscreen(state.fullscreen, action, state);

  let newState = {
    ...state
  };
  return reducers(newState, action);
}

export default myReducers;


// WEBPACK FOOTER //
// ./src/reducers/index.js